import React from 'react';
import { makeRoute, gtmSend } from '../../helpers';
import { Icon } from '../Common/Icon';

import cx from '../../styles';

const NavigationHeader = (props) => {
    const t = props.t;
    const iconColor = '#888';

    const checkIfActive = (path, url) => {
        const currentLocation = url;
        if (path == '/' && currentLocation == '/') {
            return "active";
        } else if(currentLocation == '/feed/poll' && path == '/feed'){
            return "";
        } else {
            return path != '/' && currentLocation.indexOf(path) > -1 ? "active" : "";
        }
    }

    return (
        <nav className={cx("navigation-header-wrapper")}>
            <ul>
                <li>
                    <div 
                        onClick={() => {gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tools'); props.handleLeftSlideOpen('tools');}}
                    >
                        <Icon name='tools-icon' />
                        <span>{t('tools')}</span>
                    </div>
                </li>
                <li>
                    <a 
                        href={`${props.appReducer.country === 'in' ? "https://theindusparent.com" : `https://${['th', 'id', 'my', 'vn', 'ph', 'sg'].indexOf(props.appReducer.country) !== -1 ? props.appReducer.country : 'sg'}.theasianparent.com`}`} //?utm_source=community&utm_medium=header&utm_campaign=navigation 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'article')}
                    >
                        <Icon name='article-icon' color={iconColor} />
                        <span>{t('articles')}</span>
                    </a>
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/recipes', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'recipes')}
                        className={cx(checkIfActive('/recipes', props.match.url))}
                    >
                        <Icon name='recipes-icon' color={checkIfActive('/recipes', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('recipes')}</span>
                    </Link>
                </li>*/}
                <li className={`pregnancy-icon-warp`}>
                    {
                        props.appReducer.country !== 'sg'
                        ?
                            <a 
                                href={makeRoute('/tracker', props.appReducer)} 
                                onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tracker')}
                                className={cx(checkIfActive('/tracker', props.match.url) ? 'tracker-active' : '')}
                                aria-label="Go to Pregnancy tracker page"
                            >
                                {
                                    props.match.url.includes('/tracker/baby')
                                    ?
                                        <Icon name='baby-icon-selected' />
                                    :
                                        <Icon name='pregnancy-icon-selected' />
                                }
                            </a>
                        :
                            <a 
                                href={`https://sg.theasianparent.com/pregnancy`} 
                                onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'tracker')}
                                className={cx(checkIfActive('pregnancy', props.match.url) ? 'tracker-active' : '')}
                                aria-label="Go to Pregnancy tracker page"
                            >
                                {
                                    props.match.url.includes('/tracker/baby')
                                    ?
                                        <Icon name='baby-icon-selected' />
                                    :
                                        <Icon name='pregnancy-icon-selected' />
                                }
                            </a>
                    }
                </li>
                <li>
                    <a 
                        href={makeRoute('/feed', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'feed')}
                        className={cx(checkIfActive('/feed', props.match.url))}
                    >
                        <Icon name='feed-icon' color={checkIfActive('/feed', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('menu_feed')}</span>
                    </a>
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/contests', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'contests')}
                        className={cx(checkIfActive('/contests', props.match.url))}
                    >
                        <Icon name='contest-icon' color={checkIfActive('/contests', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('contest_title')}</span>
                    </Link>
                </li>*/}
                <li>
                    <a 
                        href={makeRoute('/poll', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'poll')}
                        className={cx(checkIfActive('/poll', props.match.url))}
                    >
                        <Icon name='poll-icon' color={checkIfActive('/poll', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('community_tab_poll')}</span>
                    </a>
                </li>
                {/*<li>
                    <Link 
                        to={makeRoute('/food', props.appReducer)} 
                        onClick={() => gtmSend('dynamic', 'Icon Navigation Mobile', 'click', 'food')}
                        className={cx(checkIfActive('/food', props.match.url))}
                    >
                        <Icon name='food-icon' color={checkIfActive('/food', props.match.url) ? '#FF6464' : iconColor} />
                        <span>{t('food')}</span>
                    </Link>
                </li>*/}

                {/* <li>
                    <Link to={makeRoute('/booth', props.appReducer)} onClick={() => handleGTMEvent('Photo')} className={cx(checkIfActive('/booth', props.match.url))}>
                        <Icon name='photo-icon' color={checkIfActive('/booth', props.match.url) ? '#FF6464' : iconColor} />
                        {t('community_tab_booth')}
                    </Link>
                </li> */}
            </ul>
        </nav>
    );
}

export default NavigationHeader;